module.exports = __webpack_public_path__ + "assets/img/00170.2db1546c.png";